// extracted by mini-css-extract-plugin
export default {"countdown":"Jba-z","srOnly":"Kba-z"};